import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import appReducer from '../containers/App/reducer';
import appSaga from '../containers/App/saga';

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Configure store
export function configureAppStore() {
  const store = configureStore({
    reducer: {
      app: appReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ 
        thunk: false, 
        serializableCheck: false 
      }).concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production'
  });

  // Run root saga
  sagaMiddleware.run(appSaga);

  return store;
}

export const store = configureAppStore();

export default store;
